// Vendors
import { getStyles } from '@kubit/web-ui-components';
import styled from 'styled-components';
const WizardStepperContentComponentWrapperStyled = styled.div `
  ${({ styles }) => {
    return getStyles(styles?.container);
}}
`;
WizardStepperContentComponentWrapperStyled.displayName = 'WizardStepperComponentWrapperStyled';
export { WizardStepperContentComponentWrapperStyled };
//# sourceMappingURL=wizard-stepper.component.styled.js.map